import "./HeroSection.css";

const HeroSection = () => {
  return (
    <div className="hero-section-kf">

      {/* Lock icon */}
      <img
        src="/assets/img/hero-kf.png"
        alt="lock"
        className="hero-lock-img"
      />

      {/* Title */}
      {/* <p className="instant-approval-kf">
        Unlock your Personal<br />Loan Offer
      </p> */}
      
      {/* Instant Approval + Quick Disbursal badges */}
      {/* <img
        src="/assets/img/Group 427.png"
        alt="approval badges"
        className="hero-badges-img"
      /> */}

      {/* Google rating card */}
      {/* <img
        src="/assets/img/Group 394.png"
        alt="Google Rating"
        className="hero-rating-img-kf"
      /> */}

    </div>
  );
};

export default HeroSection;